"use strict";
var $trimStart = require("../internals/string-trim").start;
var forcedStringTrimMethod = require("../internals/string-trim-forced");
module.exports = forcedStringTrimMethod("trimStart") ? function trimStart() {
  return $trimStart(this);
} : "".trimStart;
